import React, { useState } from 'react';


const SubscriptionModal = ({
  isOpen, 
  onClose, 
  subscriptionPlans, 
  showSubscription, 
  setShowSubscription,
  subscribeProduct
}) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-end z-50">
      <div className="bg-white w-full max-w-md mx-auto rounded-t-3xl p-6 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Subscribe & Save</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            ✕
          </button>
        </div>

        {showSubscription && (
          <>
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 mb-6 flex items-center">
              <span className="text-5xl mr-4">{showSubscription.image}</span>
              <div>
                <h3 className="font-bold text-gray-800">{showSubscription.name}</h3>
                <p className="text-sm text-gray-600">{showSubscription.description}</p>
                <p className="text-lg font-bold text-blue-600 mt-1">₹{showSubscription.price}/unit</p>
              </div>
            </div>

            <h3 className="font-semibold text-gray-800 mb-3">Choose a Plan</h3>
            <div className="space-y-3 mb-6">
              {subscriptionPlans.map(plan => {
                const dailyPrice = (showSubscription.price * (100 - plan.discount)) / 100;
                const totalPrice = plan.id === 'daily' ? dailyPrice * 30 : plan.id === 'alternate' ? dailyPrice * 15 : dailyPrice * 7;
                
                return (
                  <div
                    key={plan.id}
                    className="border-2 border-gray-200 rounded-xl p-4 hover:border-blue-400 transition-all cursor-pointer"
                  >
                    <div className="flex justify-between items-start mb-2">
                      <div>
                        <h4 className="font-bold text-gray-800">{plan.name}</h4>
                        <p className="text-sm text-gray-500">{plan.duration} days</p>
                      </div>
                      <span className="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs font-bold">
                        Save {plan.discount}%
                      </span>
                    </div>
                    <div className="flex justify-between items-end">
                      <div>
                        <p className="text-xs text-gray-500 line-through">₹{showSubscription.price}/day</p>
                        <p className="text-lg font-bold text-blue-600">₹{dailyPrice.toFixed(0)}/day</p>
                      </div>
                      <button
                        onClick={() => subscribeProduct(showSubscription, plan)}
                        className="bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-600"
                      >
                        Subscribe ₹{totalPrice.toFixed(0)}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4">
              <h4 className="font-semibold text-gray-800 mb-2">✨ Subscription Benefits</h4>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• Guaranteed daily/scheduled delivery</li>
                <li>• Skip or pause anytime</li>
                <li>• Priority customer support</li>
                <li>• Exclusive subscriber discounts</li>
                <li>• Free delivery always</li>
              </ul>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default SubscriptionModal;